import { AlertTriangle } from "lucide-react";

interface QuestionnaireWarningAlertProps {
  message: string;
}

export function QuestionnaireWarningAlert({
  message,
}: QuestionnaireWarningAlertProps) {
  return (
    <div className="grid grid-cols-[auto,1fr] gap-3 rounded-md border border-orange-400/60 bg-orange-50 px-3 py-2 text-orange-600">
      <div className="flex h-5 w-5 items-center justify-center">
        <AlertTriangle className="h-4 w-4" />
      </div>
      <p className="text-sm leading-snug">{message}</p>
    </div>
  );
}
